import { FC } from 'react';
import { ButtonLink } from '@domgen/base-design-system-2.0/atoms/ButtonLink';
import { Phone } from '../../../assets/icons/Phone';
import { MouseIcon } from '../../../assets/icons/MouseIcon';
import { V2Cta, V2Frame } from '../sections/v2';
import { LandingVariantProps } from './types';

/**
 * LP2 new-UX (`phone-and-link-v1`) — phone and online CTAs side by side
 * (stacked on mobile). Phone button is the brand green (secondary tokens);
 * the online button is the muted grey (.v2-online-btn-grey wrapper — ButtonLink
 * offers no colour prop and clobbers className, so the wrapper restyles it).
 */
export const PhoneAndLinkV1: FC<LandingVariantProps> = ({ data, copy, onCtaClick }) => {
  const phoneHref = copy.ctaPhoneLink ?? data.ctaPhoneLink;
  return (
    <V2Frame
      data={data}
      copy={copy}
      cta={
        <>
          <V2Cta heading={`${copy.registration} **`} subCopy={copy.phoneSubCopy}>
            <ButtonLink
              leftIcon={Phone()}
              href={phoneHref}
              variant="secondary"
              id="phone-cta"
              onClick={() => onCtaClick('phone', phoneHref)}
            >
              {copy.ctaPhoneText}
            </ButtonLink>
          </V2Cta>
          <V2Cta
            heading={
              copy.onlineCopyDesktop ? (
                <>
                  <span className="v2-text-mobile">{copy.onlineCopy}</span>
                  <span className="v2-text-desktop">{copy.onlineCopyDesktop}</span>
                </>
              ) : (
                copy.onlineCopy
              )
            }
          >
            <div className="v2-online-btn-grey">
              <ButtonLink
                leftIcon={<MouseIcon />}
                href={data.ctaOnlineLink}
                variant="primary"
                id="online-link-cta"
                onClick={() => onCtaClick('online', data.ctaOnlineLink)}
              >
                {copy.ctaOnlineText}
              </ButtonLink>
            </div>
          </V2Cta>
        </>
      }
    />
  );
};
